import React, { lazy, Suspense } from "react";
import { Spin } from "antd";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import Users from "./users";
import Dealers from "./dealers";
import Profiles from "./profiles";
import TypemanualsAdd from "./typemanualsAdd";
import Vins from "./vins";
import Sedes from "./sedes";
import Newsletter from "./newsletter";
import Manuals from "./manuals";
import ModelsWithManuals from "./modelsWithManuals";
import Models from "./models";
import LogDownloads from "./logdownloads";
import NewslettersLogDownloads from "./newslettersdownloads";
import ManualsLogDownloads from "./manualsdownloads";
import LogUsers from "./userlogusers";
import withAdminLayout from "../../layout/withAdminLayout";

const Admin = () => {
  const { path } = useRouteMatch();
  const AdminProfile = lazy(() =>
    import("../../container/crud/adminProfile/index")
  );

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        {/* <Route exact path={`${path}`} component={Dealers} /> */}
        <Route path={`${path}/dealers`} component={Dealers} />
        {/* <Route path={`${path}/profile`} component={Profiles} /> */}
        <Route path={`${path}/users`} component={Users} />
        <Route path={`${path}/type-manuals`} component={TypemanualsAdd} />
        <Route path={`${path}/officess`} component={Sedes} />
        <Route path={`${path}/newsletters`} component={Newsletter} />
        {/* <Route path={`${path}/manuals`} component={Manuals} /> */}
        <Route
          path={`${path}/modelsWithManuals`}
          component={ModelsWithManuals}
        />
        <Route path={`${path}/models`} component={Models} />
        {/* <Route path={`${path}/vins`} component={Vins} /> */}
        {/* <Route path={`${path}/logdownloads`} component={LogDownloads} />*/}
        <Route
          path={`${path}/reports/newsletters`}
          component={NewslettersLogDownloads}
        />
        <Route
          path={`${path}/reports/manuals`}
          component={ManualsLogDownloads}
        />
        <Route path={`${path}/reports/sessions`} component={LogUsers} />
        <Route exact path={`${path}/admin-profile`} component={AdminProfile} />
      </Suspense>
    </Switch>
  );
};

export default withAdminLayout(Admin);
